import { RichTextEditor } from "@msys/ui";
import { TextFieldProps } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { convertFromRaw, RawDraftContentState } from "draft-js";
import { useField } from "formik";
import { cleanHTML, draftStateToHtml } from "../../utils.js";

interface Props {
  label: string;
  name: string;
  disabled?: boolean;
  slotProps?: TextFieldProps["slotProps"];
  value?: string;
}

export const RichTextField = ({
  value: valueProp,
  label,
  name,
  disabled,
  slotProps,
}: Props) => {
  const { t } = useTranslate(["Global"]);
  const [{ value }, , { setValue }] = useField<string>({
    name,
  });
  return (
    <RichTextEditor
      label={label}
      htmlContent={valueProp ?? value}
      onChange={async (content: RawDraftContentState) => {
        const newValue = cleanHTML(draftStateToHtml(convertFromRaw(content)));
        if (newValue !== (valueProp ?? value)) {
          await setValue(newValue);
        }
      }}
      saveButtonLabel={t("Save", { ns: "Global" })}
      cancelButtonLabel={t("Cancel", { ns: "Global" })}
      disabled={disabled}
      slotProps={slotProps}
    />
  );
};
